import { createContext, useContext } from 'react'

export interface ProfileContextType {
  /** Opens the preview; with `tab` (`achievements`), the member page on that tab instead (F-177: the preview has no tabs). */
  openProfile: (memberId: string, tab?: string) => void
}

/**
 * The context lives apart from `ProfileProvider`: that file renders the preview dialog, so editing the
 * dialog hot-reloads it, and a context created there came back as a new object the already-mounted
 * provider did not supply ("useProfileContext must be used within a ProfileProvider" in dev).
 */
export const ProfileContext = createContext<ProfileContextType | undefined>(undefined)

export const useProfileContext = () => {
  const context = useContext(ProfileContext)
  if (!context) {
    throw new Error('useProfileContext must be used within a ProfileProvider')
  }
  return context
}
